import SectionHeader from "@/components/common/section-header";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import ExpectationsAndEffort from "@/../public/images/illustrations/isa/expectationsandeffort.png";
import QuestionsForYourImpetus from "@/../public/images/illustrations/isa/questionsforyourimpetus.png";
import HelpfulInformation from "@/../public/images/illustrations/isa/helpfulinformation.png";
import GetTheResults1 from "@/../public/images/illustrations/isa/gettheresults1.png";
import GetTheResults2 from "@/../public/images/illustrations/isa/gettheresults2.png";
import Button from "@/components/common/button";
import Link from "next/link";
import dynamic from "next/dynamic";
import { isa_instructEN } from "@/assets/dictionaries/en/isa-content";
import { isa_instructES } from "@/assets/dictionaries/es/isa-content";

const IsaIns = () => {
  const [componentLoaded, setComponentLoaded] = useState(false);
  const [isaInsContent, setIsaInsContent] = useState(isa_instructEN); // Default to English

  useEffect(() => {
    // Get the language from localStorage
    const lang = localStorage.getItem("selectedOption") || "EN"; // Default to EN if not found

    // Set the content based on the language
    switch (lang.toUpperCase()) {
      case "ES":
        setIsaInsContent(isa_instructES);
        break;
      case "EN":
      default:
        setIsaInsContent(isa_instructEN);
        break;
    }
  }, []); // Only run on mount
  const LoadingComponent = () => (
    <div className="flex flex-col justify-center items-center h-[315px] mt-8">
      <div className="flex justify-center items-center">
        <div className="animate-spin rounded-full h-16 w-16 border-4 border-white border-t-4 border-t-gbci-accent"></div>
      </div>
    </div>
  );

  const DynamicIsaVideo = dynamic(
    () => import("../../../../components/common/demo-video"),
    {
      loading: () => <LoadingComponent />,
      ssr: false,
    },
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setComponentLoaded(true);
    }, 1000); // Adjust delay time as needed
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="py-20">
      <SectionHeader>
        <div className="text-gbci-accent">{isaInsContent.ins_title}</div>
      </SectionHeader>
      <div className="text-white text-xl text-center my-20">
        {isaInsContent.ins_desc}
      </div>

      <div className="w-full flex flex-col gap-8 items-center justify-between my-20 md:flex-row">
        <div className="w-full">
          <div className="text-gbci-accent text-2xl text-center font-bold mb-4">
            {isaInsContent.ins_sub_title_1}
          </div>
          <div className="text-white text-xl text-left">
            {isaInsContent.ins_sub_desc_1}
          </div>
        </div>
        <div className="w-full flex justify-center">
          <Image src={ExpectationsAndEffort} alt="dm" />
        </div>
      </div>

      <div className="w-full flex flex-col gap-8 items-center justify-between my-20 md:flex-row">
        <div className="w-full">
          <div className="text-gbci-accent text-2xl text-center font-bold mb-4">
            {isaInsContent.ins_sub_title_2}
          </div>
          <div className="text-white text-xl text-left">
            {isaInsContent.ins_sub_desc_2}
          </div>
        </div>
        <div className="w-full flex justify-center">
          <Image src={QuestionsForYourImpetus} alt="dm" />
        </div>
      </div>

      <div className="w-full flex flex-col gap-8 items-center justify-between my-20 md:flex-row">
        <div className="w-full">
          <div className="text-gbci-accent text-2xl text-center font-bold mb-4">
            {isaInsContent.ins_sub_title_3}
          </div>
          <div className="text-white text-xl text-left">
            {isaInsContent.ins_sub_desc_3_1}
          </div>
          <div className="text-white text-xl text-left mt-4">
            {isaInsContent.ins_sub_desc_3_2}
          </div>
        </div>
        <div className="w-full flex justify-center">
          <Image src={HelpfulInformation} alt="dm" />
        </div>
      </div>

      <div className="w-full flex flex-col gap-8 items-center justify-between mt-20 md:flex-row">
        <div className="w-full">
          <div className="text-gbci-accent text-2xl text-center font-bold mb-4">
            {isaInsContent.ins_sub_title_4}
          </div>
          <div className="text-white text-xl text-left">
            {isaInsContent.ins_sub_desc_4_1}
          </div>
        </div>
        <div className="w-full flex justify-center">
          <Image src={GetTheResults1} alt="dm" />
        </div>
      </div>
      <div className="w-full flex flex-col gap-8 items-center justify-between mt-8 md:flex-row md:my-4">
        <div className="w-full">
          <div className="text-white text-xl text-left">
            {isaInsContent.ins_sub_desc_4_2}
          </div>
          <div className="text-white text-xl text-left mt-4">
            {isaInsContent.ins_sub_desc_4_3}
          </div>
        </div>
        <div className="w-full flex justify-center">
          <Image src={GetTheResults2} alt="dm" />
        </div>
      </div>

      <div className="pt-20">
        <div>
          <div className="text-gbci-accent text-2xl text-center font-bold mb-4">
            {isaInsContent.ins_video_title}
          </div>
          {componentLoaded ? <DynamicIsaVideo /> : <LoadingComponent />}
        </div>
      </div>
      <div className="pt-20">
        <div>
          <div className="text-white text-xl text-center">
            {isaInsContent.ins_video_message}
          </div>
          <div className="flex justify-center mt-4">
            <Link href="/tools/isa/isa-start">
              <Button>{isaInsContent.ins_video_button}</Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IsaIns;
